import { useState, useEffect, useRef } from "react";
import productImg from "../../assets/whatsHot/goodpour_wh.webp";
import productImg2 from "../../assets/whatsHot/discotime_wh.webp";
import productImg3 from "../../assets/whatsHot/btf_wh.webp";
import productImg4 from "../../assets/whatsHot/pintoclock_model_ba.webp";
import { FaTshirt } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./productshow.css";

const slides = [
  {
    image: productImg4,
    name: "Pint O'Clock",
    url: "/shop/414091861",
  },
  {
    image: productImg,
    name: "Good Pour",
    url: "/shop/415065317",
  },
  {
    image: productImg2,
    name: "Disco Time",
    url: "/shop/431636804",
  },
  {
    image: productImg3,
    name: "Back The Farmers",
    url: "/shop/428069174",
  },
];

const ProductShow = () => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(0);
  const [direction, setDirection] = useState("right");
  const timeoutRef = useRef();

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setPrev(current);
      setDirection("right");
      setCurrent((prevIndex) => (prevIndex + 1) % slides.length);
    }, 6000);

    return () => clearTimeout(timeoutRef.current);
  }, [current]);

  const handleDotClick = (idx) => {
    if (idx === current) return;

    setPrev(current);
    setDirection(idx > current ? "right" : "left");
    setCurrent(idx);
  };

  return (
    <section className="product-show-section">
      <div className="content-padding">
        <div className="product-show-grid">
          <div className="product-show-copy">
            <p className="product-show-eyebrow">Fresh Drops</p>
            <h2>What's Hot</h2>

            <p className="product-show-text">
              Fresh drops, trending fits, and fan favourites from Solo Pints.
            </p>

            <Link to="/shop" className="product-show-btn">
              <FaTshirt />
              <span>Shop What's Hot</span>
            </Link>
          </div>

          <div className="product-show-media">
            <div className="product-show-feature-row">
              <div className="product-show-main">
                <p className="product-show-card-eyebrow">Featured drop</p>

                <Link
                  to={slides[current].url}
                  className="product-show-slider-link"
                  aria-label={`View ${slides[current].name}`}
                >
                  <div className="product-show-slider-wrapper">
                    {prev !== current && (
                      <img
                        src={slides[prev].image}
                        alt={slides[prev].name}
                        className={`product-show-slider-img slide-out-${direction}`}
                        key={`prev-${prev}`}
                        loading="lazy"
                      />
                    )}

                    <img
                      src={slides[current].image}
                      alt={slides[current].name}
                      className={`product-show-slider-img slide-in-${direction}`}
                      key={`current-${current}`}
                      loading="lazy"
                    />
                  </div>
                </Link>

                <Link to={slides[current].url} className="product-show-name">
                  {slides[current].name}
                </Link>

                <div
                  className="product-show-dots"
                  aria-label="Product carousel"
                >
                  {slides.map((slide, idx) => (
                    <button
                      key={slide.name}
                      type="button"
                      className={`product-show-dot${
                        idx === current ? " active" : ""
                      }`}
                      onClick={() => handleDotClick(idx)}
                      aria-label={`Show ${slide.name}`}
                      aria-current={idx === current ? "true" : "false"}
                    />
                  ))}
                </div>
              </div>

              <div className="product-show-up-next">
                {slides.map((slide, idx) => (
                  <button
                    key={slide.name}
                    type="button"
                    className={`product-show-thumb${
                      idx === current ? " active" : ""
                    }`}
                    onClick={() => handleDotClick(idx)}
                    aria-label={`Show ${slide.name}`}
                  >
                    <img src={slide.image} alt="" loading="lazy" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductShow;
